<template>
  <component
    :is="isMobile ? CoreBottomSheet : CoreDialog"
    v-model="isOpened"
    v-bind="isMobile ? null : { size: 'lg' }"
    title="Введите Email"
  >
    <v-form
      v-model="validForm"
      @submit.prevent="handleSubmitEmail"
    >
      <div class="text-body-1 text-secondary--text mb-4 text-left">
        Вышлем опцион и чек
      </div>
      <v-text-field
        v-model="email"
        :rules="emailValidationRules"
        :messages="emailMessages"
        append-icon="ui-icon-at-sign"
        data-qa="club__nodeEmailSendInput"
        label="Email"
        outlined
      />
    </v-form>

    <template #actions>
      <v-btn
        v-if="!isMobile"
        text
        color="text-secondary"
        @click="emit('cancel')"
      >
        Отменить
      </v-btn>
      <v-btn
        text
        color="primary"
        :disabled="isDisabledSendButton"
        data-qa="club__nodeEmailSendButton"
        @click="handleSubmitEmail"
      >
        Добавить
      </v-btn>
    </template>
  </component>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { getEmailValidation } from 'www/utils'
import CoreBottomSheet from 'src/core/CoreBottomSheet/CoreBottomSheet.vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'

const props = defineProps<{
  value: boolean
}>()

type Emits = {
  (_event: 'input', _value: boolean): void
  (_event: 'cancel'): void
  (_event: 'submit', _value: string): void
}

const emit = defineEmits<Emits>()

const isOpened = computed({
  get() {
    return props.value
  },
  set(value: boolean) {
    emit('input', value)
  },
})

const isMobile = window.MOBILE_VERSION

const email = ref('')
const emailMessages = ref('')
const validForm = ref(false)
const emailValidationData = getEmailValidation()

const isDisabledSendButton = computed(() => !validForm.value || !email.value.length)
const emailValidationRules = computed(() => {
  const {
    regex,
    onlyEn,
    required,
    maxLength,
  } = emailValidationData

  return [ // последовательность имеет значение
    required,
    maxLength,
    onlyEn,
    regex,
  ]
})

async function handleSubmitEmail() {
  if (!validForm.value) {
    return
  }

  emit('submit', email.value)
}
</script>
